let baseURL = ''
if (process.env.NODE_ENV === 'development') {
  baseURL = "/api";

} else if (process.env.NODE_ENV === 'production') {
  // baseURL = "https://shejiao-case-api.yestarshop.com";//变美 bot 1
  // baseURL = "https://case2-api.shejiao.yestarshop.com";//变美 bot 2
  baseURL = "https://case3-api.shejiao.yestarshop.com";//变美 bot 3
}
export default baseURL